import { parseCookieDomain } from '../../utils/cookie';
import { GA_ACTIVE_SESSION_COOKIE_NAME } from './constants';
import { createConfigParametersRepository } from '../../../configParametersRepository';

/**
 * Sets a cookie named '_gaActiveSession' with a value of 1 and an expiration time of half an hour.
 * The domain for the cookie is determined by the `parseCookieDomain` function.
 *
 */
export const setCookieActiveGaSession = async () => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const daysToExpire = 1 / 24 / 2; // half an hour
  storageClient?.setCookie(
    GA_ACTIVE_SESSION_COOKIE_NAME,
    1,
    daysToExpire,
    parseCookieDomain()
  );
};
